import type { PipelineContext } from '../../../../core/types';
import { SKU_RESOURCE_MODULES_FIELD } from '../../../../platform/scene-layout/types';

/**
 * 解析 fromForm / preset / 预览裁剪用的 enabledModules。
 * 与场景无关：有勾选态（非空 map）就按勾选裁；无勾选态返回 undefined（不过滤）。
 * 优先表单 `skuResourceModules`，其次 `ctx.sku.enabledModules`（非空）。
 */
export function resolveEnabledModulesForSpecFilter(
  ctx: PipelineContext,
  values: Record<string, unknown>,
): Record<string, boolean> | undefined {
  const fromForm = values[SKU_RESOURCE_MODULES_FIELD] as Record<string, boolean> | undefined;
  if (fromForm && typeof fromForm === 'object' && Object.keys(fromForm).length > 0) {
    return fromForm;
  }
  const fromCtx = ctx.sku?.enabledModules;
  if (fromCtx && typeof fromCtx === 'object' && Object.keys(fromCtx).length > 0) {
    return fromCtx;
  }
  return undefined;
}
